export default __webpack_public_path__ + "static/media/ed_4.c8b9f468.mp3";